import type { FC } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { SendShippingEvents } from '@/modules/shared/utils/gtmEvents';
import {
  ShippingEventInteractiveActions,
  ShippingEventInteractiveCategories,
  ShippingEventInteractiveTags
} from '@/modules/shared/utils/gtmEvents/types';

import Illustration from './partials/Illustration';

interface ModalProps {
  isOpen: boolean;
  onClose: VoidFunction;
}

const sendOkGroupsInformationEvent = () => {
  SendShippingEvents.sendEvent({
    event: 'baseEvent',
    extraFields: {
      'event-interactive-accion': ShippingEventInteractiveActions.Click,
      'event-interactive-category': ShippingEventInteractiveCategories.Checkout,
      'event-interactive-tag':
        ShippingEventInteractiveTags.OkButtonGroupsInformation
    }
  });
};

const sendCloseButtonGroupsInformationEvent = () => {
  SendShippingEvents.sendEvent({
    event: 'baseEvent',
    extraFields: {
      'event-interactive-accion': ShippingEventInteractiveActions.Click,
      'event-interactive-category': ShippingEventInteractiveCategories.Checkout,
      'event-interactive-tag':
        ShippingEventInteractiveTags.CloseButtonGroupsInformation
    }
  });
};

const MultiDeliveryModal: FC<ModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} size="sm">
      <ModalHeader
        icon={{
          fill: 'primary-500',
          name: 'info-circle'
        }}
        onClose={() => {
          sendCloseButtonGroupsInformationEvent();
          onClose();
        }}
        title="¿Por qué hay varias entregas?"
      />
      <ModalBody className="co-flex co-flex-col co-items-center co-pr-[20px] co-pl-[4px] co-pt-2 co-pb-[24px] co-gap-[24px] co-justify-center co-m-0">
        <div className="co-flex co-flex-col co-items-center co-gap-[32px] tablet:co-px-[16px] tablet:co-pt-[24px] tablet:co-gap-[40px]">
          <Illustration className="co-w-[150px] co-h-[150px] tablet:co-w-[200px] tablet:co-h-[200px] co-shrink-0" />
          <Text variant="body1" className="co-text-center">
            Separamos tu compra en varias entregas porque algunos productos
            están en{' '}
            <Text variant="body1" weight={600}>
              lugares diferentes
            </Text>
            . Ten en cuenta que, si cambias de dirección, las entregas podrían
            modificarse.
          </Text>
        </div>
      </ModalBody>
      <ModalFooter
        primaryButton={{
          label: 'Entendido',
          onClick: () => {
            sendOkGroupsInformationEvent();
            onClose();
          }
        }}
      />
    </Modal>
  );
};

export default MultiDeliveryModal;
